import { HttpErrorResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of, switchMap } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { FeatureSpecHttpClient } from './feature-spec.http-client';
import { FeatureSpecActions } from './feature-spec.store';

@Injectable({ providedIn: 'root' })
export class FeatureSpecEffects {
  private readonly actions$ = inject(Actions);
  private readonly http = inject(FeatureSpecHttpClient);

  public fetch$ = createEffect(() =>
    this.actions$.pipe(
      ofType(FeatureSpecActions.fetch),
      switchMap(() =>
        this.http.fetch().pipe(
          map(response => FeatureSpecActions.fetchSuccess({ payload: response.features })),
          catchError((error: HttpErrorResponse) =>
            of(FeatureSpecActions.fetchFailed({ payload: { error } })),
          ),
        ),
      ),
    ),
  );
}
